import React from "react";
import { motion } from "framer-motion";
import { Flame, Vote, Rocket } from "lucide-react";

const STEPS = [
  {
    icon: Flame,
    tag: "01",
    title: "Trending",
    accent: "#00f0ff",
    body: "We pull the most active Solana memecoins from the last 24 hours via live DexScreener data and surface the top 4 contenders.",
  },
  {
    icon: Vote,
    tag: "02",
    title: "Vote",
    accent: "#00ff66",
    body: "The community casts free votes for the coin they want to see featured. One vote per device, per round — no bots, no spam.",
  },
  {
    icon: Rocket,
    tag: "03",
    title: "Send It",
    accent: "#ffd028",
    body: "The coin with the most votes becomes the SEND IT Leader and gets pinned to the top of the homepage for 2 full hours.",
  },
];

export const HowItWorks = () => (
  <section id="how" className="px-4 sm:px-6 lg:px-8 py-12 scroll-mt-20">
    <div className="max-w-7xl mx-auto">
      <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-center">
        How <span className="neon-underline">SEND IT</span> Works
      </h2>
      <p className="text-center text-slate-400 mt-2 max-w-lg mx-auto">
        Three steps. Ten-minute rounds. The internet decides.
      </p>

      <div className="grid md:grid-cols-3 gap-5 mt-10">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.tag}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            data-testid={`how-step-${s.tag}`}
            className="relative rounded-2xl border border-white/10 bg-[#0c0f17]/80 backdrop-blur-xl p-6 overflow-hidden"
          >
            <div
              className="absolute -top-14 -right-10 h-32 w-32 rounded-full blur-3xl opacity-30"
              style={{ background: s.accent }}
            />
            <div className="flex items-center justify-between relative z-10">
              <span
                className="grid place-items-center h-12 w-12 rounded-xl border"
                style={{ color: s.accent, borderColor: `${s.accent}55`, background: `${s.accent}12` }}
              >
                <s.icon size={22} />
              </span>
              <span className="font-display font-black text-4xl text-white/10">{s.tag}</span>
            </div>
            <h3 className="font-display font-bold text-xl uppercase mt-4 relative z-10">{s.title}</h3>
            <p className="text-slate-400 text-sm mt-2 leading-relaxed relative z-10">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
